import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as customizeSlice from "../../../../redux/slices/customizeSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const PickupTime = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [sortNumber, setSortNumber] = useState(undefined);
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [imageId, setImageId] = useState(undefined);
  const [bannerType, setBannerType] = useState("Image"); // New state for banner type
  const [selectedVideo, setSelectedVideo] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState();

  const { locationData } = useSelector((state) => state.locationSlice);
  const { allPickupTimes, loading } = useSelector((state) => state.customizeSlice);

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);


  useEffect(() => {
    dispatch(customizeSlice.getPickupTimes());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = (id) => {
    setDeleteModal(true);
    setDeletableId(id);
  };

  const handleDeleteImage = async () => {
    await dispatch(customizeSlice.destroyPickupTime(deletableId));
    dispatch(customizeSlice.getPickupTimes());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Pickup Point Slot",
      selector: (row) => row?.time_slot || "-",
      sortable: true,
    },

    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allPickupTimes?.find((h) => h?.id === id);
    setId(data?.id);
    // console.log(data,"pay");
    setForm({
      ...form,
      time_slot: data?.time_slot,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const { time_slot } = form;

    formData.append("time_slot", time_slot);

    await dispatch(customizeSlice.updatePickupTime(formData, id, setForm));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getPickupTimes());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    const { time_slot } = form;
    formData.append("time_slot", time_slot);

    await dispatch(customizeSlice.storePickupTime(formData, setForm));
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getPickupTimes());
  };

  // console.log(allPickupPoints,"allPickupPoints")
  return (
    <>
      <h5 className="mb-4"> Pickup Times</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h6>Added Time Slots:</h6>
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddTempleModal(true);
            }}
          >
            Add Pickup Time 
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allPickupTimes?.length && allPickupTimes) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeleteImage}
        name={"Pickup Time"}
      />

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Update" : "Add"} Pickup Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>

             {/* Time Slot Selection */}
             <Form.Group controlId="timeInput" className="mb-3">
    <Form.Label>Select Time</Form.Label>
    <Form.Control
      type="time"
      value={form.time_slot || ""}
      onChange={(e) => setForm({ ...form, time_slot: e.target.value })}
      // disabled={!form.time_slot} // Disable if no destination is selected
    />
  </Form.Group>


          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update Slot
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save Slot
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PickupTime;
